import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[nkCapsLock]',
  standalone: false,
})
export class TrackCapslockDirective {
  // @ts-ignore
  @Output('capsLock') public capsLock = new EventEmitter<Boolean>();

  @HostListener('window:keydown', ['$event'])
  public onKeyDown(event: KeyboardEvent): void {
    const capsOn = event.getModifierState && event.getModifierState('CapsLock');
    this.capsLock.emit(capsOn);
  }
  @HostListener('window:keyup', ['$event'])
  public onKeyUp(event: KeyboardEvent): void {
    const capsOn = event.getModifierState && event.getModifierState('CapsLock');
    this.capsLock.emit(capsOn);
  }
}
